/* eslint-disable prettier/prettier */
export const section = [
  'w-full flex flex-col items-center',
  'max-w-[23.438rem] pt-[4rem] pb-[5rem]',
  'md:max-w-[90rem] md:pt-[7.5rem] md:px-0'
].join(' ');

export const heading = [
  'text-center font-bold text-[#111619]',
  'text-[1.375rem] leading-[2rem] tracking-[-0.019rem]',
  'md:text-[2.997rem] md:leading-[3.87rem] md:tracking-[-0.006rem]'
].join(' ');

export const subtitle = [
  'text-center text-[#374151] whitespace-pre-line',
  'mt-2.5 text-[0.938rem] leading-[140%] tracking-[-0.019rem]',
  'md:mt-4 md:text-[1.251rem] md:leading-[140%] md:font-medium'
].join(' ');

export const ctaButton = [
  'flex items-center justify-center gap-2 rounded-lg text-white bg-[#5025EB]',
  'mt-[1.875rem] w-[21.126rem] py-3 text-[1.125rem] leading-[1.75rem] font-medium',
  'md:mt-10 md:w-fit md:py-[1.125rem] md:px-8 md:text-[1.251rem] md:leading-[140%] md:font-bold md:bg-[#5025EB]'
].join(' ');

export const ctaArrow = ['w-[1.56rem] h-[1.56rem]', 'md:w-[1.998rem] md:h-[1.998rem]'].join(' ');
